import {Component, OnInit} from '@angular/core';
import {ErrorHandlerService} from '../shared/services/errorHandler.service';
import {ErrorEnum} from '../../enums/error.enum';

@Component({
    selector: 'eocm-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

    currentError: ErrorEnum = null;

    constructor(
        private errorHandlerService: ErrorHandlerService
    ) {
    }

    ngOnInit() {
        this.errorHandlerService.currentError.subscribe(newError => {
            this.currentError = newError;
        });
    }

    public isVideoNotFoundError() {
        return this.currentError === ErrorEnum.VIDEO_NOT_FOUND;
    }

    public isTechnicalError() {
        return this.currentError === ErrorEnum.TECHNICAL;
    }

    public isUnsupportedBrowser() {
        return this.currentError === ErrorEnum.INCOMPATIBLE_BROWSER;
    }

    public isCreditsUnavailableError() {
        return this.currentError === ErrorEnum.CREDITS_UNAVAILABLE;
    }

    public isGenerating() {
        return this.currentError === ErrorEnum.GENERATING;
    }

    public isLowBandwidthError() {
        return this.currentError === ErrorEnum.LOW_BANDWIDTH;
    }

    public isVideoUnavailableError() {
        return this.currentError === ErrorEnum.VIDEO_UNAVAILABLE;
    }

    public isHighTrafficError() {
        return this.currentError === ErrorEnum.HIGH_TRAFFIC_ERROR
    }
}
